var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "layout-mode": "tab",
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
        },
        scopedSlots: _vm._u([
          {
            key: "colStatus",
            fn: function ({ row }) {
              return [
                _c(
                  "el-tag",
                  {
                    attrs: {
                      type: row.status === 1 ? "success" : "info",
                      size: "mini",
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(row.status === 1 ? "启用" : "禁用") + " "
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "colPayinLimit",
            fn: function ({ row }) {
              return [
                _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.centsToYuan(row.payin_min_amount) ?? "-") +
                      " - " +
                      _vm._s(_vm.centsToYuan(row.payin_max_amount) ?? "-") +
                      " " +
                      _vm._s(row.currency) +
                      " "
                  ),
                ]),
              ]
            },
          },
          {
            key: "colPayinFee",
            fn: function ({ row }) {
              return [
                _vm._v(" " + _vm._s(row.payin_fee_rate + "%" || "-") + " "),
              ]
            },
          },
          {
            key: "colActions",
            fn: function ({ row }) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleEdit(row)
                      },
                    },
                  },
                  [_vm._v("编辑")]
                ),
              ]
            },
          },
        ]),
      }),
      _c("PaymentChannelDialog", {
        attrs: {
          visible: _vm.dialogVisible,
          mode: _vm.dialogMode,
          "channel-type": "payin",
          "edit-id": _vm.editId,
          "edit-row": _vm.editRow,
        },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisible = $event
          },
          success: _vm.handleDialogSuccess,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }